module.exports = __webpack_public_path__ + "static/media/arrow-right-black.5dd4b297.svg";